// extracted by mini-css-extract-plugin
export default {"animate-slow-blink":"SlYncHXbQUKzS3eBhXRq","slow-blink":"H6o1VBx4rSqA3uKtqykQ"};